import React, { useCallback } from 'react';

import NiceModal, { useModal } from '@ebay/nice-modal-react';

import MakeDecisionDialog, { type MakeDecisionProps } from 'components/dialogs/makeDecisionDialog/MakeDecisionDialog';

const Modal = NiceModal.create(({ title, body, confirmText }: MakeDecisionProps) => {
  const modal = useModal();

  const handleResolve = useCallback(() => {
    modal.resolve(true);
    modal.hide();
  }, [modal]);

  return (
    <MakeDecisionDialog
      body={body}
      confirmText={confirmText}
      open={modal.visible}
      title={title}
      onClose={modal.hide}
      onConfirmDecision={handleResolve}
      onExited={modal.remove}
    />
  );
});

export const useMakeDecisionDialog = () =>
  useCallback(async (title, body, confirmText, props?) => {
    return await NiceModal.show(Modal, { title, body, confirmText, ...props });
  }, []);
